import { LazyLoad } from 'app/utils';

export const FeaturedHashTagSortPage = LazyLoad(() => import('./index'), (module) => module.FeaturedHashTagSortPage);
